<template>
  <div id="app">
    <MainContainer/>
  </div>
</template>

<script>
import MainContainer from './components/MainContainer.vue'

export default {
  name: 'app',
  components: {
    MainContainer
  }
}
</script>

<style>

</style>
